import axiosInstance from 'src/utils/axios';
import * as Types from './types.api';

//
//

const BASE_URL = 'features/v1';

//

export const getFeaturesAPI = async ({
  merchantCode,
}: Types.FeaturesListQuery): Promise<Types.FeaturesListResponse> => {
  const response = await axiosInstance.get<Types.FeaturesListResponse>(
    `${BASE_URL}/availability/${merchantCode}`
  );

  if (!response?.data) throw new Error('Unexpected API response');

  return response.data;
};

export const getFeaturesRequirementsAPI = async (): Promise<Types.FeaturesRequirementsResponse> => {
  const response = await axiosInstance.get<Types.FeaturesRequirementsResponse>(
    `${BASE_URL}/requirements`
  );

  if (!response?.data) throw new Error('Unexpected API response');

  return response.data;
};
